import React from 'react';

const Logo = ({ size = 'medium', lightMode = false }) => {
  const heightMap = {
    small: '54px',
    medium: '76px',
    large: '105px',
    xlarge: '140px',
  };

  const logoHeight = heightMap[size] || '76px';

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img
        src="/logo_b.png"
        alt="B Digital Land survey & Consulting"
        style={{
          height: logoHeight,
          width: 'auto',
          maxHeight: logoHeight,
          objectFit: 'contain',
          display: 'block',
          filter: lightMode ? 'drop-shadow(0 2px 4px rgba(0,0,0,0.08))' : 'drop-shadow(0 2px 6px rgba(255,255,255,0.15))',
        }}
      />
    </div>
  );
};

export default Logo;
